<template lang="pug">
  bloco#coordenadoria.-padding-desktop
    //- HEADER
    template(slot="header")
      titulo.-withbar.-upper Coordenadorias
    //- CONTENT
    .conteudo(slot="content")
      carousel(
        :paginationEnabled="false",
        :navigationEnabled="true",
        :navigationClickTargetSize="0",
        :navigationNextLabel="proximo",
        :navigationPrevLabel="anterior",
        :perPage="1",
        :perPageCustom="breakpoints"
      )
        slide
          .item
            bloquinho.--turqueza-hover
              i(slot="icone").fas.fa.fa-address-book.icon-80
              template(slot="sigla") CA
              p.text-center(slot="texto") Coordenadoria Administrativa.
        slide
          .item
            bloquinho.--turqueza-hover
              i(slot="icone").proad.proad-onibus
              template(slot="sigla") CGT
              p(slot="texto") A Coordenadoria de Transportes compete, coordenar a gestão da frota de veículos de uso comum e de uso institucional.
        slide
          .item
            bloquinho.--turqueza-hover
              i(slot="icone").fas.fa.fa-handshake-o.icon-80
              template(slot="sigla") CC
              p.text-center(slot="texto") Coordenadoria de Convênios.
        slide
          .item
            bloquinho.--turqueza-hover
              font-awesome-icon(icon="archway" size="4x" slot="icone")
              template(slot="sigla") CGEF
              p.text-center(slot="texto") Coordenadoria de Gestão de Espaços Físicos.
        slide
          .item
            bloquinho.--turqueza-hover
              font-awesome-icon(icon="sitemap" size="4x" slot="icone")
              template(slot="sigla") CGI
              p.text-center(slot="texto") Coordenadoria de Gestão da Informação.
</template>

<style lang="scss">
  #coordenadoria {
    .item {
      display: block;
      margin: 0 auto;
      max-width: 137px;
      .proad { font-size: 4rem; line-height: 50px; }
      &:hover { text-decoration: none}

      .icon-80 {
        transform: scale(0.8);
      }
    }

    @include media("<desktop") {
      > .conteudo {
        margin: 0 20px;
      }
    }

    .carousel-arrows {
      color: $color-grey-normal;
    }
  }
</style>

<script>
import Bloco from 'COMPONENTS/Bloco'
import Bloquinho from 'COMPONENTS/Bloquinho'
import Titulo from 'COMPONENTS/ElementTitle'
import { Carousel, Slide } from 'vue-carousel'
export default {
  props: ['breakpoints'],
  components: {
    Bloco,
    Bloquinho,
    Titulo,
    Carousel,
    Slide
  },
  data: () => ({
    proximo: '<i class="fa fa-angle-right fa-4x carousel-arrows">',
    anterior: '<i class="fa fa-angle-left fa-4x carousel-arrows">'
  })
}
</script>



// WEBPACK FOOTER //
// Coordenadorias.vue?61b38cbf